var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-header-box" },
    [
      _c("div", { staticClass: "nav-header" }, [
        _c("div", { staticClass: "nav-left" }, [
          _c("a", { on: { click: _vm.backHome } }, [
            _vm.$root.tenantInfo.logoUrl
              ? _c("img", {
                  staticClass: "logo",
                  attrs: {
                    src: _vm.$root.tenantInfo.logoUrl,
                    alt: _vm.$root.tenantInfo.name
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "s-name" }, [
            _vm._v(_vm._s(_vm.$root.tenantInfo.name))
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !(
                  _vm.menus.length == 1 &&
                  _vm.$root.userInfo.roleCodes == "specialist"
                ),
                expression:
                  "!(menus.length == 1 && $root.userInfo.roleCodes == 'specialist')"
              }
            ],
            staticClass: "main-nav"
          },
          [
            _c(
              "el-menu",
              {
                ref: "elMenu",
                attrs: {
                  "default-active": _vm.activeIndex,
                  mode: "horizontal",
                  "menu-trigger": "hover"
                },
                on: { select: _vm.handleSelect }
              },
              [
                _vm._l(_vm.menus, function(item) {
                  return [
                    item.children && item.children.length > 0 && !item.isHide
                      ? _c(
                          "el-submenu",
                          {
                            key: item.id,
                            attrs: {
                              index: item.path,
                              "popper-class": "sub-item"
                            }
                          },
                          [
                            _c("template", { slot: "title" }, [
                              _c("span", [_vm._v(_vm._s(item.name))])
                            ]),
                            _vm._v(" "),
                            _vm._l(item.children, function(sItem) {
                              return _c(
                                "el-menu-item",
                                {
                                  key: sItem.menuID,
                                  attrs: { index: sItem.path }
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { slot: "title" }, slot: "title" },
                                    [_vm._v(_vm._s(sItem.name))]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _c(
                          "el-menu-item",
                          {
                            key: item.path,
                            class: {
                              "is-active":
                                item.path.indexOf(_vm.parentActiveIndex) >= 0
                            },
                            attrs: { index: item.path }
                          },
                          [_c("span", [_vm._v(_vm._s(item.name))])]
                        )
                  ]
                })
              ],
              2
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nav-right" },
          [
            _vm.msItem
              ? [
                  _c(
                    "el-link",
                    {
                      staticClass: "link",
                      on: {
                        click: function($event) {
                          return _vm.handleSelect(_vm.msItem.path)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.msItem.name))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "v-line" })
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "inline-block",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.wxDialogShow.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "el-popover",
                  {
                    attrs: {
                      placement: "bottom",
                      trigger: "hover",
                      "popper-class": "popper-code"
                    }
                  },
                  [
                    _c("div", { staticClass: "text-center" }, [
                      _c("img", {
                        staticStyle: { height: "100px" },
                        attrs: { src: "/static/img/wx_code.jpg", alt: "" }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "iconfont icon wx-icon",
                        attrs: { slot: "reference" },
                        slot: "reference"
                      },
                      [_vm._v("")]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("span", { staticClass: "v-line" }),
            _vm._v(" "),
            _c("div", { staticClass: "inline-block mr-10" }, [
              !_vm.$root.userInfo.userAvatarUrl
                ? _c("img", {
                    staticClass: "avatar",
                    attrs: { src: "/static/img/defalut_head.jpg", alt: "" },
                    on: {
                      click: function($event) {
                        return _vm.modifyInfo("show")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$root.userInfo.userAvatarUrl
                ? _c("img", {
                    staticClass: "avatar",
                    attrs: { src: _vm.$root.userInfo.userAvatarUrl, alt: "" },
                    on: {
                      click: function($event) {
                        return _vm.modifyInfo("show")
                      }
                    }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "font-15" }, [_vm._v("欢迎您，")]),
            _vm._v(" "),
            _c(
              "el-dropdown",
              { attrs: { trigger: "click" } },
              [
                _c("span", { staticClass: "el-dropdown-link" }, [
                  _c("span", { staticClass: "font-15 name" }, [
                    _vm._v(_vm._s(_vm.userInfo.realName))
                  ]),
                  _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
                ]),
                _vm._v(" "),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _c(
                      "el-dropdown-item",
                      {
                        nativeOn: {
                          click: function($event) {
                            return _vm.modifyInfo("show")
                          }
                        }
                      },
                      [_vm._v("个人设置")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-item",
                      {
                        nativeOn: {
                          click: function($event) {
                            return _vm.logOut.apply(null, arguments)
                          }
                        }
                      },
                      [_vm._v("退出登录")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "个人信息设置",
            visible: _vm.dialogVisible,
            width: "800px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                padding: "0px",
                "min-height": "300px",
                "margin-top": "-15px"
              }
            },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.handleModifyType },
                  model: {
                    value: _vm.modifyType,
                    callback: function($$v) {
                      _vm.modifyType = $$v
                    },
                    expression: "modifyType"
                  }
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "修改基础信息", name: "1" }
                  }),
                  _vm._v(" "),
                  _c("el-tab-pane", { attrs: { label: "修改密码", name: "2" } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.modifyType == "1",
                      expression: "modifyType == '1'"
                    }
                  ],
                  ref: "userForm",
                  staticClass: "mt-20",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "90px"
                  }
                },
                [
                  _c("el-form-item", { attrs: { label: "登录账号：" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.$root.userInfo.loginName))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名：", prop: "realName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "用户姓名" },
                        model: {
                          value: _vm.form.realName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "realName", $$v)
                          },
                          expression: "form.realName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "昵称：", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "用户昵称" },
                        model: {
                          value: _vm.form.name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "性别：", prop: "sex" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.sex,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "sex", $$v)
                            },
                            expression: "form.sex"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("男")
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("女")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "民族：", prop: "nation" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { filterable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.form.nation,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "nation", $$v)
                            },
                            expression: "form.nation"
                          }
                        },
                        _vm._l(_vm.nationList, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "用户头像：", prop: "name" } },
                    [
                      !_vm.form.userAvatarUrl
                        ? _c("img", {
                            staticClass: "user-avatar",
                            attrs: {
                              src: "/static/img/defalut_head.jpg",
                              alt: ""
                            },
                            on: { click: _vm.toggleShow }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.form.userAvatarUrl
                        ? _c("img", {
                            staticClass: "user-avatar",
                            attrs: { src: _vm.form.userAvatarUrl, alt: "" },
                            on: { click: _vm.toggleShow }
                          })
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.modifyType == "2",
                      expression: "modifyType == '2'"
                    }
                  ],
                  ref: "userForm2",
                  staticClass: "mt-20",
                  attrs: {
                    model: _vm.form2,
                    rules: _vm.rules2,
                    "label-width": "100px"
                  }
                },
                [
                  _c("el-form-item", { attrs: { label: "登录账号：" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.$root.userInfo.loginName))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "原密码：", prop: "oldPwd" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入原密码", type: "password" },
                        model: {
                          value: _vm.form2.oldPwd,
                          callback: function($$v) {
                            _vm.$set(_vm.form2, "oldPwd", $$v)
                          },
                          expression: "form2.oldPwd"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "新密码：", prop: "newPwd" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入新密码", type: "password" },
                        model: {
                          value: _vm.form2.newPwd,
                          callback: function($$v) {
                            _vm.$set(_vm.form2, "newPwd", $$v)
                          },
                          expression: "form2.newPwd"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "确认密码：", prop: "checkPwd" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "再次输入新密码",
                          type: "password"
                        },
                        model: {
                          value: _vm.form2.checkPwd,
                          callback: function($$v) {
                            _vm.$set(_vm.form2, "checkPwd", $$v)
                          },
                          expression: "form2.checkPwd"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function($event) {
                      return _vm.modifyInfo("hide")
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.show
        ? _c("my-upload", {
            attrs: {
              modelValue: _vm.show,
              size: "2.1",
              url: _vm.action,
              "img-format": "png",
              headers: _vm.headers
            },
            on: {
              "update:modelValue": function($event) {
                _vm.show = $event
              },
              "update:model-value": function($event) {
                _vm.show = $event
              },
              "crop-upload-success": _vm.cropUploadSuccess
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-838253f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-838253f2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pc/components/shared/NavHeader.vue
// module id = 511
// module chunks = 14